import React, { useState, useEffect } from "react";
import { Row } from "react-bootstrap";
import Layout from "template";
import { MenuItems } from "template/MenuItems";
import { GramamReportCard } from "./GramamReportsCards";
import { GramamSthayiReportCard } from "./GramamSthayiReports"
import { Link } from "react-router-dom";
import { APIService } from "services";
import {
  useParams
} from "react-router-dom";




export const GramamReport: React.FC = () => {
  const [GramamCount, setGramamCount] = useState([])
  const [gramamSthayiReports, setGramamSthayiReports] = useState([])
  const { id } = useParams();
  // console.log("16nagartype",nagar_type)
  localStorage.setItem("upamandal_basthi_id", id)
  const [isLoading, setIsLoading] = React.useState(false);

  // localStorage.removeItem("basthi_id");
  useEffect(() => {
    // console.log("15id",type_id)
    setIsLoading(true)
    APIService.api().post("https://lhac.lokahitam.net/api/v1/samithi_members/searchWithFields", { type: "upamandal", type_id: id }).then((response) => {
      console.log("22responsefromgramamsscreen", response)
      let vibhagData = response.data.SamithiReport
      let array = []
      array.push(response.data.SamithiReport[0])
      if (array && array.length > 0) {
        const filteredArray = array.filter(item => item !== undefined);
        setIsLoading(false)
        setGramamSthayiReports(filteredArray)
      }
      setGramamCount(vibhagData)
    }).catch((err) => {
      console.log(err)
    })
  }, [1000]);

  let nagar_khandaId = localStorage.getItem('nagar_khanda_id')
  let jilla_id = localStorage.getItem("jilla_id")
  // console.log("nagar_khandaId",nagar_khandaId)
  let vibhag_id = localStorage.getItem("vibhag_id")
  // console.log("210nagar_khandaId",nagar_khandaId)
  let upamandal_basthi_id = localStorage.getItem("upamandal_basthi_id")
  let MemberName = localStorage.getItem('member_name')
  let vibhagName = localStorage.getItem('vibhag_name')
  let jillaName = localStorage.getItem('zilla_name')
  let upMandalName = localStorage.getItem('upamandal_name')
  // console.log("44upMandalNamein gramamspage",upMandalName)
  let nagarKhandaName = localStorage.getItem('nagar_khanda_name')
  // let upMandalName=localStorage.getItem('upamandal_name')
  let gramamName = localStorage.getItem('gramam_name')
  // console.log("44upMandalNamegramamspage",upMandalName)
  let bastiName = localStorage.getItem('basti_name')

  let DesignationId = parseInt(localStorage.getItem("desig_level_id"))

  return (
    <Layout>
      <div className="container-fluid" >
        <div className="d-sm-flex align-items-center justify-content-between mb-4" >
          {/* <h1 className="h3 mb-0 text-gray-800" > Gramam </h1> */}
        </div>

        <nav aria-label="breadcrumb">

          <ol className="breadcrumb" >


            {(DesignationId === 1 || DesignationId === 2) &&

              <li className="breadcrumb-item" ><Link to="/vibhagreports" style={{ color: "#194380" }}>{vibhagName}</Link></li>
            }
            {(DesignationId === 1 || DesignationId === 2 || DesignationId === 3) &&

              (vibhag_id != "undefined" && vibhag_id && vibhag_id != "null") &&
              <li className="breadcrumb-item" ><Link to={'/jillareports/' + vibhag_id} style={{ color: "#194380" }}>{jillaName}</Link></li>


            }
            {(DesignationId === 1 || DesignationId === 2 || DesignationId === 3 || DesignationId === 4) &&
              <li className="breadcrumb-item"><Link to={'/nagarkhandareports/' + jilla_id} style={{ color: "#194380" }}>{nagarKhandaName}</Link></li>
            }
            {(DesignationId === 1 || DesignationId === 2 || DesignationId === 3 || DesignationId === 4
              || DesignationId === 5) &&
              (upMandalName != "undefined" && upMandalName && upMandalName != "null") &&
              <li className="breadcrumb-item" ><Link to={"/upmandalbasthireports/" + nagar_khandaId} style={{ color: "#194380" }}>{upMandalName}</Link></li>

            }


          </ol>
        </nav>
        <div className="h5 mb-0 font-weight-bold text-gray-800">
          <p>Namasthe , {MemberName} 🙏</p></div>
        <div className="d-flex flex-column min-vh-100" >
          {isLoading ? (
            <div className="d-flex justify-content-center" style={{ marginTop: "230px" }}>
              <div className="spinner-border" role="status">
                <span className="visually-hidden"></span>
              </div>
            </div>
          ) :
            <Row>
              {gramamSthayiReports.map((item, i) => {
                return <GramamSthayiReportCard key={`Card-${i}`} id={item.id} nagar_type={item.nagar_type} total_gramas_count={item.total_gramas_count} total_gramas_formed={item.total_gramas_formed} gramam_name={item.gramam_name} gramams_formed={item.gramams_formed} members_registered={item.members_registered} total_basti={item.total_basti} total_gramas={item.total_gramas} />
              })}
            </Row>
          }
          {isLoading ? (
            <div className="d-flex justify-content-center" style={{ marginTop: "230px" }}>
              <div className="spinner-border" role="status">
                <span className="visually-hidden"></span>
              </div>
            </div>
          ) :
            (
              <Row>
                {GramamCount.map((item, i) => {
                  return <GramamReportCard key={`Card-${i}`} id={item.id} nagar_type={item.nagar_type} gramam_name={item.gramam_name} gramams_formed={item.gramams_formed} members_registered={item.members_registered} total_basti={item.total_basti} total_gramas={item.total_gramas} />
                })}
              </Row>
            )}
        </div>
      </div></Layout >
  );
};

